module.exports = __webpack_public_path__ + "static/img/logo_ob.fbb8c23.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/video/logo_ob.webp
// module id = abmN
// module chunks = 3